module.exports = __webpack_public_path__ + "assets/img/znggmx.80251626.png";